<template>
  <div :class="'comm_record ' + 'comm_record' + uniqueId">
    <div class="record_list" v-if="!onlyShowAtinput">
      <div class="list_one_item" v-for="(item,index) in commlistdata">
        <div class="item_default">
          <div class="item_top">
            <div class="item_peopleInfo">
              <img class="item_headImg" :src="item.headImg?item.headImg:defaultHeadImg" :alt="cutString(item.createUserName,4)"
                   :title="item.createUserName">
              <span class="item_name" :title="item.createUserName">{{ item.createUserName }}</span>
              <img class="follow" src="icons/pc/other/hr_gd_16_16.png?v=1.0" alt="跟盯" v-if="item.isShowFollowBtn"
                   @click="follow(item)">
            </div>
            <el-tooltip placement="top">
              <div slot="content">
                <div v-if="item.fromObjType === 'stdrsm'">来源：人才库</div>
                <div v-if="item.fromObjType === 'appfile' || item.fromObjType === 'offer'">
                <div class="recruit_process" style="margin-bottom: 5px;"><span>招聘职位：{{ item.positionname }}（{{ item.positionnumber }}）</span></div>
                  <div class="recruit_process"><span>{{ item.recrustg }}：{{ item.recrustat }}</span></div>
                </div>
              </div>
              <img class="item_source" src="icons/pc/other/hr_ryxx_16_16.png?v=1.0" alt="来源信息">
            </el-tooltip>
          </div>
          <div class="item_body" v-if="!item.deleteState">
            <div class="item_text"><span style="color: #5582F3">#{{ item.commthemeName }}# </span><span v-html="item.commthemeContent"></span>
            </div>
            <div class="item_topic" v-if="item.topicObj && item.topicObj.length">
              <div class="topic_subitem" v-for="(topicItem,topicIndex) in item.topicObj">
                <span class="topic_title">{{ topicItem.value }}：</span><span class="topic_content">{{ topicItem.selectedValue }}</span>
                <span v-if="topicIndex<item.topicObj.length - 1">；</span>
              </div>
            </div>
            <div class="item_commconclusion" v-if="item.commconName && item.conopt">
              <div class="commconclusion_subitem">
                <span class="conclu_title">{{ item.commconName }}：</span><span class="conclu_content">{{ item.conopt }}</span>
              </div>
            </div>
            <div class="item_bottom">
              <div class="comment_time">{{ dateFormat('yyyy-MM-dd hh:mm', item.updateTimeDate) }}</div>
              <div class="item_op" v-if="!item.deleteState">
                <el-popconfirm
                    :popper-class="'popConfirm'"
                    :hide-icon="true"
                    :title="getLangMsg('commRecord_key001')"
                    @confirm="deleteCommRec('theme',item.commrecId)"
                >
                  <div class="delete" v-if="item.isShowDeleteBtn" slot="reference">{{ getLangMsg("commRecord_delete") }}</div>
                </el-popconfirm>
                <div class="divide" v-if="item.isShowDeleteBtn"></div>
                <div class="edit_clusion" v-if="item.isShowEditConopBtn" @click="editClusion(item)">{{ getLangMsg("commRecord_editClusion") }}</div>
                <div class="divide" v-if="item.isShowEditConopBtn"></div>
                <div class="reply" @click="reply('one',item)">{{ getLangMsg("commRecord_reply") }}</div>
              </div>
            </div>
          </div>
          <div class="is_delete" v-if="item.deleteState">
            <div>{{ getLangMsg("commRecord_key002") }}</div>
            <div>{{ dateFormat('yyyy-MM-dd hh:mm', item.updateTimeDate) }}</div>
          </div>
        </div>
        <div class="list_two" v-if="item.commrcvs">
          <div class="list_two_item" v-for="(itemTwo,index) in item.commrcvs">
            <div class="item_default">
              <div class="item_top">
                <div class="item_peopleInfo">
                  <img class="item_two_headImg" :src="itemTwo.headImg?itemTwo.headImg:defaultHeadImg" :alt="itemTwo.createUserName"
                       :title="itemTwo.createUserName">
                  <span class="item_name">{{ itemTwo.createUserName }}</span>
                </div>

                <el-tooltip placement="top">
                  <div slot="content">
                    <div v-if="itemTwo.fromObjType === 'stdrsm'">来源：人才库</div>
                    <div v-if="itemTwo.fromObjType === 'appfile' || item.fromObjType === 'offer'">
                      <div class="recruit_process" style="margin-bottom: 5px;"><span>招聘职位：{{ itemTwo.positionname }}（{{ itemTwo.positionnumber }}）</span></div>
                      <div class="recruit_process"><span>{{ itemTwo.recrustg }}：{{ itemTwo.recrustat }}</span></div>
                    </div>
                  </div>
                  <img class="item_source" src="icons/pc/other/hr_ryxx_16_16.png?v=1.0" alt="来源信息">
                </el-tooltip>

              </div>
              <div class="item_body" v-if="!itemTwo.deleteState">
                <div class="item_text">
                  <span>{{ getLangMsg("commRecord_reply") }}<span class="__at_span" :data-id="itemTwo.repliedcreatorId"
                                contenteditable="false">@{{ itemTwo.repliedcreatorName }}</span></span>
                  <span v-html="itemTwo.rcvcontent"></span>
                </div>
                <div class="item_bottom">
<!--                  <div class="recruit_process"><span>{{ itemTwo.recrustg }}-{{ itemTwo.recrustat }}</span></div>-->
                  <div class="comment_time">{{ dateFormat('yyyy-MM-dd hh:mm', itemTwo.createTime) }}</div>
                  <div class="item_op" v-if="!itemTwo.deleteState">
                    <el-popconfirm
                        :popper-class="'popConfirm'"
                        :hide-icon="true"
                        :title="getLangMsg('commRecord_key001')"
                        @confirm="deleteCommRec('reply',itemTwo.commrcvId)"
                    >
                      <div class="delete" v-if="itemTwo.isShowDeleteBtn" slot="reference">{{ getLangMsg("commRecord_delete") }}</div>
                    </el-popconfirm>
                    <div class="divide" v-if="itemTwo.isShowDeleteBtn"></div>
                    <div class="reply" @click="reply('two',item,itemTwo)">{{ getLangMsg("commRecord_reply") }}</div>
                  </div>
                </div>
              </div>
              <div class="is_delete" v-if="itemTwo.deleteState">
                <div>{{ getLangMsg("commRecord_key003") }}</div>
                <div>{{ dateFormat('yyyy-MM-dd hh:mm', itemTwo.createTime) }}</div>
              </div>
            </div>
          </div>
        </div>
        <InputBox :key="item.commrecId" :ref="'inputBox'+item.commrecId" :atInputUniqueId="item.commrecId"
                  :commrecItem="item" :cusParam_searchPeoples="cusParam_searchPeoples"></InputBox>
      </div>
      <div class="more_data" v-if="(commlistdata && commlistdata.length) && (cusParam_pageOpenType && cusParam_pageOpenType === 'msg')"><span @click="getMoreCommrec">查看全部</span></div>
      <div class="noListData" v-if="!(commlistdata && commlistdata.length)">
        <img :src="nodataImg" alt="">
        <div>{{ getLangMsg("commRecord_key004") }}</div>
      </div>
    </div>
    <div class="speech_board" v-if="onlyShowAtinput">
      <InputBox class="input_area" key="0001" ref="inputBox0001" :atInputUniqueId="'0001'"
                :cusParam_release="cusParam_release"
                :cusParam_searchPeoples="cusParam_searchPeoples" :onlyShowAtinput="onlyShowAtinput"></InputBox>
    </div>
  </div>
</template>
<script>
import InputBox from "./InputBox.vue";

export default {
  components: {
    InputBox
  },
  props: {
    onlyShowAtinput: Boolean,
    cusParam_release: Number,
    cusParam_commlistdata: Array,
    cusParam_searchPeoples: Array,
    cusParam_srcollBottom: Number,
    cusParam_clearInputText: String,
    cusParam_pageOpenType:String
  },
  watch: {
    cusParam_commlistdata: function (val) {
      for (let dataItem in val) {
        val[dataItem].isShowReply = true;
      }
      this.commlistdata = val;
    },
    cusParam_srcollBottom: function (val) {
      this.scrollBottom();
    },
    cusParam_clearInputText: function (val) {
      val = val.split("-")[0]
      let atInputRef = val === '0001' ? this.$refs['inputBox' + val] : this.$refs['inputBox' + val][0]
      atInputRef.initAtInputArea();
    }

  },
  filters: {

  },
  data() {
    return {
      uniqueId:0,
      commlistdata: [],
      defaultHeadImg: "images/pc/emotion/default_person_82_82.png?v=1.0",
      nodataImg: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKgAAABhCAMAAAB1chr6AAAAhFBMVEUAAADy9Pn////y9fzy9fny9fry9vv29v/y9fry9frz9vvy8vj////z9vrz9/vy9frz9PTy9frz9vrz9vry9Prz9fvy9vry9fr09vvy9fry9fvy9vvy9fvz9fvz8//x9Pnx9fry9vvv8/f0+f/r6+7y+Pjx9Pnz9vvy9vry9fre4ebq7fLn24UVAAAAKXRSTlMAfARQSFk3HWqMYSYMLj+dFK6llL+D2NBy4rZy8ukVhMjHQC4MJreIwQV8H3oAAAJCSURBVHja7dvdTqtAFIZhZvgp2NIfdeMgbKkWxbrv//52CQK1Ml1ruhJnYtebiDBHT2jynTT1OI7jOO5Msin36IRnr2Zv0D+L0tIIalG6N4LipdahWKl9KFLqABQndQGKkjoBxUjdgCKkjkBhqStQUOoMFJK6AwWkDkEvkNKhH31Gbu9MDGUoQxnKUCehQwxlKEOvBPphGEP75LJ6z8syf08C6TC0LrJyKBcLV6FB9vdLme8kVFb5t5SL0CabKHFvntTDZLFr0Gh76Pmz7dDz1jFovbnX5BjUf2x7e3sc+zyhQ2WQdNtcvUiqU642uqjQhcjLoayoadD0Vtv5eQKh/uk2B7RPfqWNBlX5t4S8RDgPRZKIUNxpI0GTbKLGnLmOEzAKNH6YTJk6Z6L6M1QdGu/HEwq0XeZ+n493OjJ8n0ogokDvNW1qI2iolCqK9q9rfFJDRbEndLLM45Nv9MHHqCjQja6VNIBGN6go0FttqQE0CFFRoCttvsnI46JA77SJbr/nqDeKiwJNwOI1DF2+HFr2DU+nJxRoBe+0mIHQCBcFKhAV4DtN03S3S4eOn3aH+hMKFLPTKoSg89fX+XGaZwo0RjWDBh8XBXqDKgKg66en9aH+2v0/vu+uFGiIKgCgi666XoxNnFGgPi4AKnFRoAGuVkOPAkXsdJt9aITLPhSx0232oeBOd9mHznDZhwI73V/tQ4Gd7u/tQyUu+1AP7mq/uWPoFULLy52l95M1l0Mbjxz9Ry1wZSM9juM4jvsF/Qe1eUljmww3OQAAAABJRU5ErkJggg=="
    }
  },
  mounted() {
    this.uniqueId = Math.floor(Math.random()*10000);
    this.scrollBottom();
  },
  methods: {
    /**
     * 点击回复，打开回复输入框
     * @param level 被回复的父节点等级
     * @param recItem 主题对象
     * @param rcvItem 回复的父节点对象（一级节点回复，此参为空）
     */
    reply(level, recItem, rcvItem) {
      this.$refs['inputBox' + recItem.commrecId][0].openAtInputArea(level, recItem, rcvItem, this.uniqueId);
    },

    /**
     * 删除一条沟通记录
     * @param type 沟通记录类型（主题记录/回复记录）
     * @param id 记录id
     */
    deleteCommRec(type, id) {
      let params = {
        "dataType": type,  //数据类型
        "id": id
      }
      this.invoke("form_deleteData", params);
    },

    /**
     * 编辑结论
     * @param item 沟通记录主题对象
     */
    editClusion(item) {
      if (!item) { return; }
      let params = {
        "commrecId": item.commrecId,
        "commthemeId": item.commthemeId,
        "conoptId": item.conoptId
      }
      this.invoke("form_selectCommConclu", params)
    },

    /**
     * 点击跟盯
     * @param item 沟通记录主题对象
     */
    follow(item) {
      if (!item) { return; }
      this.invoke("form_toFollowList", item.commrecId)
    },

    /**
     * 沟通记录列表滚动到最底部
     */
    scrollBottom() {
      this.$nextTick(() => {
        // $(".comm_record").animate({scrollTop: $(".comm_record")[0].scrollHeight + 'px'}, 500);
        $(".comm_record" + this.uniqueId).scrollTop($(".comm_record" + this.uniqueId)[0].scrollHeight)
      })
    },
    /**
     * 获取全部的沟通记录
     */
    getMoreCommrec(){
      this.invoke("form_getAllCommrecList","1")
    }
  }
}
</script>
<style lang="less">
.comm_record {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: auto;
  padding: 10px 16px 0;
  font-size: 12px;

  .record_list {
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .list_one_item {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      flex-shrink: 0;
      flex-grow: 0;
      background: #F5F5F5;
      border-radius: 2px;
      padding: 0 16px 12px;
      margin-bottom: 8px;

      .item_default {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        padding: 12px 0;
        border-bottom: 1px dashed #999999;

        .item_top {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .item_source{
            width: 16px;
            height: 16px;
          }
          .item_peopleInfo {
            display: flex;
            align-items: center;

            .item_headImg {
              width: 36px;
              height: 36px;
              border-radius: 50%;
            }
            .item_two_headImg{
              width: 30px;
              height: 30px;
              border-radius: 50%;
            }

            .item_name {
              color: #212121;
              font-size: 14px;
              margin-left: 8px;
              margin-right: 15px;
              max-width: 60px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }

            .follow {
              margin-right: 16px;
              cursor: pointer;
            }
          }
        }

        .item_body {
          flex-grow: 1;
          flex-shrink: 1;
          display: flex;
          flex-direction: column;
          align-items: stretch;

          .item_text {
            color: #333;
            line-height: 18px;
            margin-top: 8px;
            word-wrap: break-word;
            .__at_span {
              color: #0E5FD8;
              margin-right: 8px;
            }
          }

          .item_topic{
            margin-top: 8px;
            display: flex;
            .topic_subitem{

            }
            .topic_title{
              color: #999;
            }
            .topic_content{
              color: #333;
            }
          }
          .item_commconclusion {
            margin-top: 8px;
            color: #999999;
            display: flex;
            .commconclusion_subitem{
              height: 20px;
              line-height: 20px;
              background: #FFF;
              border: 1px solid #666;
              border-radius: 10px;
              padding: 0 8px;
            }
            .conclu_title{
              color: #333;
            }
            .conclu_content{
              color: #666;
            }
          }

          .item_bottom {
            display: flex;
            justify-content: space-between;
            margin-top: 8px;

            .item_op {
              display: flex;
              align-items: center;
              font-size: 12px;
              color: #0F5FD8;

              .edit_clusion, .delete, .reply {
                cursor: pointer;
              }

              .divide {
                width: 1px;
                height: 8px;
                background: #CCCCCC;
                margin: 0 8px;
              }
            }

            .comment_time {
              color: #999999;
              line-height: 18px;
            }
          }
        }

        .is_delete {
          margin: 8px 0 0 12px;
          color: #999999;
          display: flex;
          justify-content: space-between;
        }
      }

      .list_two {
        margin-left: 15px;

        .item_default {
          padding-left: 8px;
        }
      }
    }

    .more_data{
      display: flex;
      align-items: center;
      justify-content: center;
      span{
        color: #5582F3;
        cursor: pointer;
      }
    }

    .noListData {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 50px;
      font-size: 14px;
      color: #666;
      -webkit-box-ordinal-group: 1;

      img {
        margin-bottom: 8px;
      }
    }
  }

  .speech_board {
    flex-grow: 0;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .option {
      flex-grow: 0;
      flex-shrink: 0;
      display: flex;
      align-items: center;
    }

    .input_area {
      flex-shrink: 0;
      flex-grow: 0;
    }
  }
}

.popConfirm {
  .el-popconfirm__action {
    .el-button--text {
      color: #5582F3;
    }

    .el-button--primary {
      background-color: #5582F3;
      border-color: #FFFFFF;
      position: relative;

      &:before {
        content: "";
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        position: absolute;
        background-color: hsla(0, 0%, 100%, .35);
        display: none;
      }

      &:hover:before {
        display: block;
      }
    }
  }
}
</style>